import fetcher from '@/core/lib/fetcher'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { Room, roomFormValues } from './rooms.types'
import { APIResponse } from '@/core/types/utils'

export const roomsQueryOptions = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['rooms', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `property/${siteId}/room`)
        .json<Promise<APIResponse<Room[]>>>(),
    staleTime: 1000 * 60 * 10,
  })

export const roomByIdQueryOptions = (id: string, token: string) =>
  queryOptions({
    queryKey: ['room', id, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `property/room/${id}`)
        .json<Promise<APIResponse<Room>>>(),
  })

export const createRoom = (
  data: roomFormValues,
  propertyId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/${propertyId}/room`)
    .post(data)
    .json()

export const updateRoom = (
  data: roomFormValues,
  roomId: string,
  token: string
) => {
  return fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/room/${roomId}`)
    .put(data)
    .json()
}

export const useDeleteRoom = (token: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(import.meta.env.VITE_API_BOOKING + `property/room/${id}`)
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['rooms'],
      })
    },
  })
}

export const validateRoomCode = (
  propertyId: string,
  roomCode: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(
      import.meta.env.VITE_API_BOOKING +
        `property/${propertyId}/room/check-code/${encodeURIComponent(roomCode)}`
    )
    .get()
    .json()
